export type AppErrorCode =
  | "mic-not-supported"
  | "mic-permission-denied"
  | "mic-no-audio"
  | "stt-failed"
  | "stt-empty"
  | "structure-failed"
  | "tts-failed"
  | "offline"
  | "submit-failed";

export class AppError extends Error {
  constructor(
    public code: AppErrorCode,
    message: string
  ) {
    super(message);
    this.name = "AppError";
  }
}
